const CART_RECOMMENDATIONS_COLLAPSED_KEY = 'cartRecommendationsCollapsed';

if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    static current = null;

    connectedCallback() {
      // A drawer re-render brings an empty placement; keep the filled one (see decisions.md: Cart).
      const previous = CartRecommendations.current;
      if (previous && previous !== this && !previous.isConnected) {
        this.replaceWith(previous);
        previous.refresh();
        return;
      }
      CartRecommendations.current = this;

      if (this.initialized) return;
      this.initialized = true;

      this.placement = this.querySelector('.nosto_element');
      this.accordion = this.querySelector('accordion-element');
      this.prevButton = this.querySelector('.cart_recommendations_prev');
      this.nextButton = this.querySelector('.cart_recommendations_next');

      // Collapsed survives page loads for the session; within a page the element itself is kept.
      try {
        if (sessionStorage.getItem(CART_RECOMMENDATIONS_COLLAPSED_KEY)) this.accordion?.close(true);
      } catch (e) {}
      this.querySelector('.cart_recommendations_toggle')?.addEventListener('click', () => {
        try {
          if (this.accordion.classList.contains('open')) sessionStorage.removeItem(CART_RECOMMENDATIONS_COLLAPSED_KEY);
          else sessionStorage.setItem(CART_RECOMMENDATIONS_COLLAPSED_KEY, '1');
        } catch (e) {}
      });

      this.prevButton.addEventListener('click', () => this.step(-1));
      this.nextButton.addEventListener('click', () => this.step(1));
      this.placement.addEventListener('scroll', this.updateArrows.bind(this), { capture: true, passive: true });
      new MutationObserver(this.onPlacementChange.bind(this)).observe(this.placement, {
        childList: true,
        subtree: true,
      });
      this.onPlacementChange();

      this.addEventListener('click', this.onQuickAddOpen.bind(this), true);
      document.body.addEventListener('modalClosed', this.onQuickAddClose.bind(this));
    }

    get track() {
      return this.placement.querySelector('.cart_recommendations_track');
    }

    step(direction) {
      const track = this.track;
      if (track) track.scrollBy({ left: direction * track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      const track = this.track;
      const maxScroll = track ? track.scrollWidth - track.clientWidth : 0;
      this.prevButton.disabled = !track || track.scrollLeft <= 1;
      this.nextButton.disabled = !track || track.scrollLeft >= maxScroll - 1;
    }

    // The block is display: none until Nosto's cards arrive, so the accordion first measured 0.
    onPlacementChange() {
      this.accordion?.refreshHeight();
      this.updateArrows();
    }

    // Only re-inject when the products changed, so a quantity change doesn't blink the cards.
    refresh() {
      if (typeof window.nostojs !== 'function') return;
      const id = this.placement.id;

      window.nostojs((api) => {
        api
          .createRecommendationRequest({ includeTagging: true })
          .setElements([id])
          .setResponseMode('HTML')
          .disableCampaignInjection()
          .loadRecommendations()
          .then((response) => {
            const recommendation = response.recommendations?.[id];
            if (!recommendation) return;
            const handles = [...(recommendation.html || '').matchAll(/handle="([^"]*)"/g)].map((match) => match[1]);
            const current = [...this.placement.querySelectorAll('nosto-dynamic-card')].map((card) =>
              card.getAttribute('handle')
            );
            if (handles.join() === current.join()) return;
            api.placements.injectCampaigns({ [id]: recommendation });
          })
          .catch((e) => console.error(e));
      });
    }

    // The quick-add modal sits above the drawer and hands focus and scroll lock back when it closes.
    onQuickAddOpen(event) {
      if (!event.target.closest('modal-opener button')) return;
      const drawer = this.closest('cart-drawer');
      this.drawerActiveElement = drawer?.activeElement;
      this.quickAddOpener = event.target.closest('button');
    }

    onQuickAddClose() {
      if (!this.quickAddOpener) return;
      const drawer = this.closest('cart-drawer');
      const opener = this.quickAddOpener;
      this.quickAddOpener = null;
      if (!drawer) return;
      drawer.setActiveElement(this.drawerActiveElement);
      if (!drawer.classList.contains('active')) return;
      document.body.classList.add('overflow-hidden');
      if (opener.isConnected) trapFocus(document.getElementById('CartDrawer'), opener);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
